/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Quicktools_SpeakersInputs */

const en_options_quicktools_speakers = /** @type {(inputs: Options_Quicktools_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speakers`)
};

const fr_options_quicktools_speakers = /** @type {(inputs: Options_Quicktools_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locuteurs`)
};

const de_options_quicktools_speakers = /** @type {(inputs: Options_Quicktools_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprecher`)
};

const it_options_quicktools_speakers = /** @type {(inputs: Options_Quicktools_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altoparlanti`)
};

const ru_options_quicktools_speakers = /** @type {(inputs: Options_Quicktools_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Докладчики`)
};

const es_options_quicktools_speakers = /** @type {(inputs: Options_Quicktools_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oradores`)
};

const zh_cn2_options_quicktools_speakers = /** @type {(inputs: Options_Quicktools_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`演讲者`)
};

const ja_options_quicktools_speakers = /** @type {(inputs: Options_Quicktools_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`講演者`)
};

const hi_options_quicktools_speakers = /** @type {(inputs: Options_Quicktools_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वक्ताओं`)
};

const pt_pt2_options_quicktools_speakers = /** @type {(inputs: Options_Quicktools_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palestrantes`)
};

/**
* | output |
* | --- |
* | "Speakers" |
*
* @param {Options_Quicktools_SpeakersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_quicktools_speakers = /** @type {((inputs?: Options_Quicktools_SpeakersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Quicktools_SpeakersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_quicktools_speakers(inputs)
	if (locale === "de") return de_options_quicktools_speakers(inputs)
	if (locale === "it") return it_options_quicktools_speakers(inputs)
	if (locale === "ru") return ru_options_quicktools_speakers(inputs)
	if (locale === "es") return es_options_quicktools_speakers(inputs)
	if (locale === "zh-CN") return zh_cn2_options_quicktools_speakers(inputs)
	if (locale === "ja") return ja_options_quicktools_speakers(inputs)
	if (locale === "hi") return hi_options_quicktools_speakers(inputs)
	if (locale === "pt-PT") return pt_pt2_options_quicktools_speakers(inputs)
	return en_options_quicktools_speakers(inputs)
});